/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Unknown` - UNKNOWN
 * * `Agent` - AGENT
 * * `Import` - IMPORT
 * * `Onboarding` - ONBOARDING
 * * `Recurrence` - RECURRENCE
 * * `Template` - TEMPLATE
 * * `Public API` - PUBLIC_API
 * * `Email` - EMAIL
 * * `Slack` - SLACK
 * * `CLI` - CLI
 * * `Application` - APPLICATION
 * * `AppTcm` - APP_TCM
 * * `AppInternalForm` - APP_INTERNAL_FORM
 * * `AppQuickAdd` - APP_QUICK_ADD
 * * `AppBoard` - APP_BOARD
 * * `AppSubtask` - APP_SUBTASK
 * * `AppRelationship` - APP_RELATIONSHIP
 * * `AppEnter` - APP_ENTER
 * * `AppReplicate` - APP_REPLICATE
 * * `AppPaste` - APP_PASTE
 * * `AppRoadmapList` - APP_ROADMAP_LIST
 * * `AppRoadmapTimeline` - APP_ROADMAP_TIMELINE
 * * `ExternalForm` - EXTERNAL_FORM
 */
export enum TaskSourceKind {
  UNKNOWN = 'Unknown',
  AGENT = 'Agent',
  IMPORT = 'Import',
  ONBOARDING = 'Onboarding',
  RECURRENCE = 'Recurrence',
  TEMPLATE = 'Template',
  PUBLIC_API = 'Public API',
  EMAIL = 'Email',
  SLACK = 'Slack',
  CLI = 'CLI',
  APPLICATION = 'Application',
  APP_TCM = 'AppTcm',
  APP_INTERNAL_FORM = 'AppInternalForm',
  APP_QUICK_ADD = 'AppQuickAdd',
  APP_BOARD = 'AppBoard',
  APP_SUBTASK = 'AppSubtask',
  APP_RELATIONSHIP = 'AppRelationship',
  APP_ENTER = 'AppEnter',
  APP_REPLICATE = 'AppReplicate',
  APP_PASTE = 'AppPaste',
  APP_ROADMAP_LIST = 'AppRoadmapList',
  APP_ROADMAP_TIMELINE = 'AppRoadmapTimeline',
  EXTERNAL_FORM = 'ExternalForm',
}
